import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ReportOnOffBoardResultDto} from "../../generated-model/model";
import {environment} from "../../environments/environment";
import {IgnoreNullHttpParams} from "../shared/commons/Ignore-null-http-params";

@Injectable({providedIn: "root"})
export class ErmRegisterResource {
  http = inject(HttpClient);

  public searchReportOnOffBoard(personalId: string) {
    return this.http.get<ReportOnOffBoardResultDto[]>(`${environment.serverUrl}/api/erm-register/uc/history`, {
      params: IgnoreNullHttpParams.fromObject({personalId: personalId}).toHttpParam()
    });
  }
}
